
import { LOAD_ITEM_REQUEST_DETAIL, REMOVE_ITEM_REQUEST_DETAIL } from './actions';


export const itemRequestDetail = (state={},action)=>{
    const {type,payload}=action;
    switch (type) {
        case LOAD_ITEM_REQUEST_DETAIL:
            return {...payload};

        case REMOVE_ITEM_REQUEST_DETAIL: 
           return {};
           
        default:
            return state;
    }
}